module.exports = __webpack_public_path__ + "static/img/zhenjiu.2a2dfff.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/zhenjiu.png
// module id = 7x3s
// module chunks = 1